import { render, staticRenderFns } from "./PartnerCharities.vue?vue&type=template&id=b21d1ebe"
import script from "./PartnerCharities.vue?vue&type=script&lang=js"
export * from "./PartnerCharities.vue?vue&type=script&lang=js"
import style0 from "./PartnerCharities.vue?vue&type=style&index=0&id=b21d1ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports